import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import seoConfig from "../assets/seoConfig.js";

export default function PageHeader({ seoKey }) {
  const location = useLocation();

  const segments = location.pathname.split("/").filter(Boolean);

  // Format slug → Title
  const formatTitle = (str) =>
    str.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const fallbackTitle =
    segments.length > 0 ? formatTitle(segments[segments.length - 1]) : "Home";

  // Pick SEO data
  const seoData = seoKey
    ? seoConfig.pages[seoKey] || {}
    : { title: fallbackTitle };

  const meta = { ...seoConfig.default, ...seoData };

  const pageTitle = `${meta.title} | ${seoConfig.default.siteName}`;
  const pageUrl = window.location.origin + location.pathname;

  // Fallback for document.title
  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <div className="container py-4">
      <Helmet>
        {/* Title + Description */}
        <title>{pageTitle}</title>
        <meta name="description" content={meta.description} />

        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:type" content={meta.type} />
        <meta property="og:url" content={pageUrl} />
        {meta.image && <meta property="og:image" content={meta.image} />}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={meta.description} />
        {meta.image && <meta name="twitter:image" content={meta.image} />}
      </Helmet>
      <br />
      {/* Title */}
      <h2 className="fw-bold text-center">{meta.title}</h2>

      {/* Breadcrumb */}
      <nav
        aria-label="breadcrumb"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>

          {segments.map((seg, idx) => {
            const path = "/" + segments.slice(0, idx + 1).join("/");
            const isLast = idx === segments.length - 1;
            return (
              <li
                key={idx}
                className={`breadcrumb-item ${isLast ? "active" : ""}`}
                aria-current={isLast ? "page" : undefined}
              >
                {isLast ? (
                  formatTitle(seg)
                ) : (
                  <a href={path}>{formatTitle(seg)}</a>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
